import { CoursesRequests } from '@/modules/courses-requests/types';
import { UserRoles } from '@/enums';

const access_roles = {
  [CoursesRequests.Pages.COURSES_REQUESTS]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER,
  ],
  [CoursesRequests.Pages.COURSES_REQUEST_NEW]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER,
  ],
  [CoursesRequests.Pages.COURSES_REQUEST_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER,
  ],
  [CoursesRequests.Pages.COURSES_REQUEST_EDIT]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER,
  ],
};

export default access_roles;
